'use client'

import React, { useState, useEffect, useRef } from 'react'
import Image from 'next/image'

// Datos de galería - SOLO 24 FOTOS (4 slides completos)
const galleryImages = [
  // 1-4: Google Ads
  { id: 1, category: "Publicidad", description: "Campaña Google Ads 07", image: "/images/optimized/google_ads_airlovers_07-gallery.webp", thumbnail: "/images/optimized/google_ads_airlovers_07-thumbnail.webp" },
  { id: 2, category: "Publicidad", description: "Campaña Google Ads 08", image: "/images/optimized/google_ads_airlovers_08-gallery.webp", thumbnail: "/images/optimized/google_ads_airlovers_08-thumbnail.webp" },
  { id: 3, category: "Publicidad", description: "Campaña Google Ads 09", image: "/images/optimized/google_ads_airlovers_09-gallery.webp", thumbnail: "/images/optimized/google_ads_airlovers_09-thumbnail.webp" },
  { id: 4, category: "Publicidad", description: "Campaña Google Ads 10", image: "/images/optimized/google_ads_airlovers_10-gallery.webp", thumbnail: "/images/optimized/google_ads_airlovers_10-thumbnail.webp" },
  
  // 5-10: DSC series
  { id: 5, category: "Aventura", description: "Vuelo DSC04706", image: "/images/optimized/DSC04706-gallery.webp", thumbnail: "/images/optimized/DSC04706-thumbnail.webp" },
  { id: 6, category: "Paisajes", description: "Paisaje DSC04656", image: "/images/optimized/DSC04656-gallery.webp", thumbnail: "/images/optimized/DSC04656-thumbnail.webp" },
  { id: 7, category: "Vuelo", description: "Vuelo DSC04659", image: "/images/optimized/DSC04659-gallery.webp", thumbnail: "/images/optimized/DSC04659-thumbnail.webp" },
  { id: 8, category: "Equipo", description: "Equipo DSC04663", image: "/images/optimized/DSC04663-gallery.webp", thumbnail: "/images/optimized/DSC04663-thumbnail.webp" },
  { id: 9, category: "Personas", description: "Clientes DSC04686", image: "/images/optimized/DSC04686-gallery.webp", thumbnail: "/images/optimized/DSC04686-thumbnail.webp" },
  { id: 10, category: "Celebración", description: "Cumpleaños DSC04692", image: "/images/optimized/DSC04692-gallery.webp", thumbnail: "/images/optimized/DSC04692-thumbnail.webp" },
  
  // 11-16: Más fotos (reemplazamos propuestas con hamburguesa y juli)
  { id: 11, category: "Comida", description: "Hamburguesa especial", image: "/images/optimized/hamburguesa_01.webp", thumbnail: "/images/optimized/hamburguesa_01.webp" },
  { id: 12, category: "Personas", description: "Juli disfrutando del vuelo", image: "/images/optimized/juli_01.webp", thumbnail: "/images/optimized/juli_01.webp" },
  { id: 13, category: "Experiencias", description: "Experiencia 3f6bd2cd", image: "/images/optimized/3f6bd2cd-3a64-439b-ba5c-5a6058405389-gallery.webp", thumbnail: "/images/optimized/3f6bd2cd-3a64-439b-ba5c-5a6058405389-thumbnail.webp" },
  { id: 14, category: "Experiencias", description: "Experiencia 801a8e42", image: "/images/optimized/801a8e42-52b6-43b6-936e-8bfaa298aeb6-gallery.webp", thumbnail: "/images/optimized/801a8e42-52b6-43b6-936e-8bfaa298aeb6-thumbnail.webp" },
  { id: 15, category: "Experiencias", description: "Experiencia 91c6ca6e", image: "/images/optimized/91c6ca6e-5ee8-49f4-8214-9378413f07b3-gallery.webp", thumbnail: "/images/optimized/91c6ca6e-5ee8-49f4-8214-9378413f07b3-thumbnail.webp" },
  { id: 16, category: "Paisajes", description: "Paisaje IMG_4762", image: "/images/optimized/IMG_4762-gallery.webp", thumbnail: "/images/optimized/IMG_4762-thumbnail.webp" },
  
  // 17-18: Últimas fotos (volvemos a 18 total)
  { id: 17, category: "Paisajes", description: "Paisaje IMG_4769", image: "/images/optimized/IMG_4769-gallery.webp", thumbnail: "/images/optimized/IMG_4769-thumbnail.webp" },
  { id: 18, category: "Paisajes", description: "Paisaje IMG_4775", image: "/images/optimized/IMG_4775-gallery.webp", thumbnail: "/images/optimized/IMG_4775-thumbnail.webp" }
]

// Configuración - 6 fotos por slide (2×3) - 24 fotos = 4 slides completos
const PHOTOS_PER_SLIDE = 6
const TOTAL_SLIDES = Math.ceil(galleryImages.length / PHOTOS_PER_SLIDE) // 4 slides

const GalleryMobileSlider24 = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const sliderRef = useRef<HTMLDivElement>(null)
  const touchStartX = useRef(0)
  const touchEndX = useRef(0)

  // Calcular fotos del slide actual
  const getCurrentSlideImages = () => {
    const startIndex = currentSlide * PHOTOS_PER_SLIDE
    return galleryImages.slice(startIndex, startIndex + PHOTOS_PER_SLIDE)
  }

  // Navegación
  const goToSlide = (slideIndex: number) => {
    if (slideIndex >= 0 && slideIndex < TOTAL_SLIDES) {
      setCurrentSlide(slideIndex)
    }
  }

  const goToNextSlide = () => {
    goToSlide(currentSlide + 1)
  }

  const goToPrevSlide = () => {
    goToSlide(currentSlide - 1)
  }

  // Touch handlers
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX
  }

  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX
  }

  const handleTouchEnd = () => {
    const swipeThreshold = 50
    const diff = touchStartX.current - touchEndX.current

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        goToNextSlide()
      } else {
        goToPrevSlide()
      }
    }
  }

  // Lightbox functions
  const openLightbox = (imageIndex: number) => {
    setCurrentImageIndex(imageIndex)
    setLightboxOpen(true)
    document.body.style.overflow = 'hidden'
  }

  const closeLightbox = () => {
    setLightboxOpen(false)
    document.body.style.overflow = 'auto'
  }

  const goToPreviousImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? galleryImages.length - 1 : prevIndex - 1
    )
  }

  const goToNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === galleryImages.length - 1 ? 0 : prevIndex + 1
    )
  }

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!lightboxOpen) return
      
      switch (e.key) {
        case 'Escape':
          closeLightbox()
          break
        case 'ArrowLeft':
          goToPreviousImage()
          break
        case 'ArrowRight':
          goToNextImage()
          break
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [lightboxOpen])

  return (
    <div className="w-full">
      {/* Header */}
      <div className="mb-4 text-center">
        <p className="text-gray-600">
          <span className="font-semibold text-primary-blue">{galleryImages.length}</span> fotos • 
          Slide <span className="font-semibold">{currentSlide + 1}</span> de <span className="font-semibold">{TOTAL_SLIDES}</span>
        </p>
        <p className="mt-1 text-sm text-gray-500">
          {getCurrentSlideImages().length} fotos • 4 slides completos
        </p>
      </div>

      {/* Slider container */}
      <div 
        ref={sliderRef}
        className="relative overflow-hidden rounded-xl bg-gray-50 p-4"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Grid 2×3 - Siempre 6 fotos por slide */}
        <div className="grid grid-cols-2 grid-rows-3 gap-3">
          {getCurrentSlideImages().map((image, index) => {
            const globalIndex = currentSlide * PHOTOS_PER_SLIDE + index
            return (
              <div 
                key={image.id}
                className="relative aspect-square overflow-hidden rounded-lg bg-white shadow-md"
                onClick={() => openLightbox(globalIndex)}
              >
                <Image
                  src={image.thumbnail}
                  alt={image.description}
                  fill
                  className="object-cover"
                  sizes="(max-width: 768px) 50vw, 33vw"
                />
                

              </div>
            )
          })}
        </div>

        {/* Flechas de navegación */}
        <button
          onClick={goToPrevSlide}
          disabled={currentSlide === 0}
          className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-white/80 p-2 shadow-lg disabled:opacity-30 disabled:cursor-not-allowed"
          aria-label="Slide anterior"
        >
          <svg className="h-5 w-5 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <button
          onClick={goToNextSlide}
          disabled={currentSlide === TOTAL_SLIDES - 1}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-white/80 p-2 shadow-lg disabled:opacity-30 disabled:cursor-not-allowed"
          aria-label="Slide siguiente"
        >
          <svg className="h-5 w-5 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* Dots - Solo 4 dots (4 slides) */}
      <div className="mt-4 flex justify-center space-x-2">
        {Array.from({ length: TOTAL_SLIDES }).map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`h-2 w-2 rounded-full ${index === currentSlide ? 'bg-primary-blue' : 'bg-gray-300'}`}
            aria-label={`Ir al slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Información */}
      <div className="mt-2 text-center text-xs text-gray-500">
        <p>✅ {galleryImages.length} fotos • {TOTAL_SLIDES} slides • Sin último grupo</p>
      </div>
    </div>
  )
}

export default GalleryMobileSlider24